import { render } from "./RatingButton.vue?vue&type=template&id=38442b00"
import script from "./RatingButton.vue?vue&type=script&lang=js"
export * from "./RatingButton.vue?vue&type=script&lang=js"

import "./RatingButton.vue?vue&type=style&index=0&id=38442b00&lang=postcss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__